import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AclService } from '@common-services/util/acl.service';
import { BinaryFunction } from '@dice/app/types/dice.types';

@Component({
  selector: 'table-column-checkbox2',
  templateUrl: './table-column-checkbox2.component.html',
  standalone: false,
})
export class TableColumnCheckbox2Component<T> implements OnChanges {
  private aclService = inject(AclService);

  @Input() isHeader?: boolean; // unused, fixes console error after angular update

  @Input() type?: string; // unused, fixes console error after angular update

  @Input() element: T;

  @Input() name?: string;

  @Input() permission?: string;

  @Input() tooltip?: string;

  @Input() cssClass?: string | string[] = [];

  @Input() selectionAttribute?: string;

  @Input() onChange?: BinaryFunction<T, boolean>;

  static readonly sortEnabled = false;

  hasPermission: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    const { permission } = changes;
    if (!!permission && permission.firstChange) {
      this.hasPermission = this.aclService.hasPermission(this.permission);
    }
  }

  _changed(checked: boolean): void {
    if (this.onChange) {
      this.onChange(this.element, checked);
    }
  }
}
